//BrokerAccessModal.jsx

import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Spin, message, Modal } from 'antd';
import api from '../functions/api';
import getUserId from '../functions/getUserId';
import { useSelector, useDispatch } from 'react-redux';
import { getPortfolioData, getFavoritesData } from '../redux/reducers/portfolioReducer';
import useLocalStorage from '../functions/useLocalStorage';

const BrokerAccessModal = ({ isVisible, onClose }) => {
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [isSaxoAvailable, setIsSaxoAvailable] = useState(false);
    const [isDeGiroAvailable, setIsDeGiroAvailable] = useState(false);
    const [authorizationTrigger, setAuthorizationTrigger] = useState(false);
    const dispatch = useDispatch();
    const [token, setToken] = useLocalStorage('token', null);
    const [showInfoModal, setShowInfoModal] = useState(false);


    useEffect(() => {
        // console.log("isVisible:", isVisible, "selectedBroker:", selectedBroker);
        if (isVisible || selectedBroker|| authorizationTrigger) {
            const userId = getUserId();
            console.log("brokercheckavailable use effect run")
            api.post('/Broker_checkifauthorisationavailable', { userId })
               .then(response => {
                     console.log("Broker check if authorisation available response:", response.data);
                   setIsSaxoAvailable(response.data.saxo);
                   setIsDeGiroAvailable(response.data.degiro);
                   if (authorizationTrigger) setAuthorizationTrigger(false);
               })
               .catch(error => {
                   console.error("Failed to check broker authorization:", error);
               });
        }
    }, [isVisible, selectedBroker, authorizationTrigger]);
    
    const handleResetDeGiro = () => {
    setIsDeGiroAvailable(false);
    setSelectedBroker('DeGiro');
};


    const handleBrokerSelection = (broker) => {
        console.log("handleBrokerSelection called with:", broker);
        // setAuthorizationTrigger(true);
        setSelectedBroker(broker);
    };

    const renderLoginForm = () => {
        switch (selectedBroker) {
            case 'DeGiro':
                return <DeGiroLoginForm dispatch={dispatch} token={token} setShowInfoModal={setShowInfoModal} />;

                // return <DeGiroLoginForm dispatch={dispatch} token={token} />;
            case 'Saxo':
                return <SaxoLoginForm dispatch={dispatch} token={token} setAuthorizationTrigger={setAuthorizationTrigger} isSaxoAvailable={isSaxoAvailable} />;
            default:
                return null;
        }
    };
    
    

    return (

        <>

        <Modal
            title="Select Your Broker to autorise to this website"
            open={isVisible} 
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="ok" type="primary" onClick={onClose}>
                    OK
                </Button>,
               
            ]}
             >
              <Button disabled={isDeGiroAvailable} onClick={() => handleBrokerSelection('DeGiro')}>DeGiro</Button>
            <Button disabled={isSaxoAvailable} onClick={() => handleBrokerSelection('Saxo')}>Saxo</Button>

{isDeGiroAvailable && (
    <Button type="default" onClick={handleResetDeGiro} style={{ marginLeft: 8 }}>
        Reset DeGiro
    </Button>
)}

            <p>if button 'DeGiro' is inactive than according to our database you already have authorized the application to your broker account</p>
            <p>However for DeGiro if needed you then can use the reset DeGiro button to reset credentials</p>
           
            {renderLoginForm()}
        </Modal>

        <Modal
  title="How to authorize your DeGiro account"
  open={showInfoModal}
  onCancel={() => setShowInfoModal(false)}
  footer={[
    <Button key="close" onClick={() => setShowInfoModal(false)}>
      Close
    </Button>
  ]}
  width={900}
>
  <div style={{ maxHeight: '75vh', overflowY: 'auto', textAlign: 'center' }}>
    {[1, 2, 3].map((page) => (
      <img
        key={page}
        src={`/assets/Authorize_degiro_page${page}.png`}
        alt={`DeGiro Auth Page ${page}`}
        style={{ width: '100%', maxWidth: '850px', marginBottom: 16 }}
      />
    ))}
  </div>
</Modal>



        </>

    );
};

const DeGiroLoginForm = ({ dispatch, token, setShowInfoModal }) => {

// const DeGiroLoginForm = ({ dispatch, token }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        const userId = getUserId();

        const payload = {
            userid: userId,
            dg_username: values.username,
            dg_password: values.password,
            totp_secret_key: values.totp_secret_key
        };

        try {
            setLoading(true);
            const response = await api.post(`/initial_check_DeGiro_credentials/${userId}`, payload);
            console.log("DeGiro Auth response:", response.data);

            if (response.data.success) {
                message.success("DeGiro authorization successful");
                dispatch(getPortfolioData(token));
                dispatch(getFavoritesData(token));
            } else {
                message.error("DeGiro authorization failed: " + (response.data.error || "Unknown error"));
            }
        } catch (err) {
            console.error("Authorization error:", err);
            message.error("API error: " + (err.response?.data?.error || err.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <Form form={form} onFinish={handleFinish} layout="vertical">
                <h3>
                        DeGiro account authorisation.&nbsp;
                        <Button type="link" onClick={() => setShowInfoModal(true)} style={{ padding: 0 }}>
                            Read this
                        </Button>
                    </h3>


                <Form.Item
                    label="Your DeGiro userid"
                    name="username"
                    rules={[{ required: true, message: 'Please enter your DeGiro userid' }]}
                >
                    <Input
                        placeholder="e.g. johnjones123"
                        autoComplete="off"
                        name="username"
                        data-lpignore="true"
                    />
                </Form.Item>

                <Form.Item
                    label="Your DeGiro password"
                    name="password"
                    rules={[{ required: true, message: 'Please enter your DeGiro password' }]}
                >
                    <Input.Password
                        placeholder="Password"
                        autoComplete="new-password"
                        name="password"
                        data-lpignore="true"
                    />
                </Form.Item>

                <Form.Item
                    label="Your DeGiro totp_secret_key"
                    name="totp_secret_key"
                    rules={[
                        { required: true, message: 'Please enter your TOTP Secret Key' },
                        {
                            validator: (_, value) =>
                                value && value.length === 32
                                    ? Promise.resolve()
                                    : Promise.reject(new Error('TOTP Secret Key must be exactly 32 characters'))
                        }
                    ]}
                >
                    <Input
                        placeholder="32 characters like AF5YBXHXFKWNRT2AYI47YAJ4QSCJBIRT"
                        autoComplete="off"
                        name="totp_secret_key"
                        data-lpignore="true"
                    />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Authorize
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );
};




const SaxoLoginForm = ({ dispatch, token, setAuthorizationTrigger, isSaxoAvailable }) => {
    const [loading, setLoading] = useState(false);
    const [smsStep, setSmsStep] = useState(false); // Track SMS step
    const [smsCode, setSmsCode] = useState(''); // Store SMS code
    const [credentials, setCredentials] = useState(null); // Store credentials temporarily

    const handleSaxoAuthorization = async (values) => {
        try {
            setLoading(true);
            const userId = getUserId();
            const { username, password } = values;

            console.log("Submitting initial authorization:", { userId, username, password });

            // Save credentials for the next step
            setCredentials({ userId, username, password });

            // API call for initial authorization
            const response = await api.post('/Initial_Saxo_Authorisation', {
                userId,
                username,
                password,
            });

            console.log("API Response:", response.data);

            if (response.data.requiresSms) {
                console.log("SMS Step required");
                setSmsStep(true); // Move to SMS step
            } else {
                message.success("Authorization successful");
                setAuthorizationTrigger(true);
                dispatch(getPortfolioData(token));
            }
        } catch (error) {
            console.error("Error during authorization:", error);
            message.error("Error during authorization: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSmsSubmit = async () => {
        try {
            setLoading(true);

            console.log("Submitting SMS code:", smsCode);

            // API call for submitting SMS code
            const response = await api.post('/Submit_Saxo_SmsCode', {
                userId: credentials.userId,
                username: credentials.username,
                password: credentials.password,
                smsCode,
            });

            console.log("SMS Submit Response:", response.data);

            if (response.data.success) {
                message.success("SMS verification successful");
                setAuthorizationTrigger(true);
                dispatch(getPortfolioData(token));
                setSmsStep(false);
            } else {
                message.error("SMS verification failed");
            }
        } catch (error) {
            console.error("Error during SMS verification:", error);
            message.error("Error during SMS verification: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <Button onClick={() => setLoading(false)} style={{ marginBottom: "10px" }}>
        Stop Spinner (Debug)
    </Button>
            {!smsStep ? (
                <Form onFinish={handleSaxoAuthorization}>
                    <h3>Saxo Account Authorization</h3>
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your Username!' }]}
                    >
                        <Input placeholder="Username" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input.Password placeholder="Password" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={isSaxoAvailable}>
                            Authorize
                        </Button>
                    </Form.Item>
                </Form>
            ) : (
                <div>
                    <h3>Enter SMS Code</h3>
                    <Input
                        placeholder="SMS Code"
                        value={smsCode}
                        onChange={(e) => setSmsCode(e.target.value)}
                    />
                    <Button type="primary" onClick={handleSmsSubmit}>
                        Submit SMS Code
                    </Button>
                </div>
            )}
        </Spin>
    );
};


export default BrokerAccessModal;
